import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "../Helpers/Classnames";
import MobileNavigation from "./MobileNavigation";



export default function Navigation() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navigation = [
    {
      name: "Home",
      href: "/",
      end: true,
      type: "route"
    },
    {
      name: "About",
      href: "/#about",
      sectionId: "about",
      type: "anchor"
    },
    {
      name: "About Carly",
      href: "/#about-carly",
      sectionId: "about-carly",
      type: "anchor"
    },
    {
      name: "Support",
      href: "/#support",
      sectionId: "support",
      type: "anchor"
    },
    {
      name: "Where",
      href: "/#where",
      sectionId: "where",
      type: "anchor"
    },
    {
      name: "Yoga",
      href: "/#yoga-events",
      sectionId: "yoga-events",
      type: "anchor"
    },
    {
      name: "Investment",
      href: "/investment",
      type: "route"
    },
    {
      name: "Testimonials",
      href: "/testimonials",
      type: "route"
    },
    {
      name: "FAQs",
      href: "/faqs",
      type: "route"
    }
  ]

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    const mainContainer = document.querySelector("main");
    if (!section) return;

    if (mainContainer) {
      const targetTop = section.offsetTop - 16;
      mainContainer.scrollTo({ top: targetTop, behavior: "smooth" });
      return;
    }

    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleSectionNav = (event, sectionId) => {
    event.preventDefault();

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(sectionId), 150);
      return;
    }

    scrollToSection(sectionId);
  };

  return (
    <nav className="my-auto p-5">
      {/* Desktop nav */}
      <div className="flex items-center gap-3">
        <div className="hidden lg:flex">
          {navigation.map((item) => {
            if (item.type === "anchor") {
              return (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={(event) => handleSectionNav(event, item.sectionId)}
                  className="flex my-auto mx-1 px-3 py-1.5 text-lg rounded-md text-white hover:bg-coastal-100 hover:text-coastal-900"
                >
                  {item.name}
                </a>
              );
            }

            return (
              <NavLink key={item.name} to={item.href} end={item.end ? item.end : false}>
                {({ isActive }) => (
                  <span
                    className={classNames(
                      isActive
                        ? "text-coastal-200"
                        : "text-white hover:bg-coastal-100 hover:text-coastal-900",
                      "flex my-auto mx-1 px-3 py-1.5 text-lg rounded-md"
                    )}
                  >
                    {item.name}
                  </span>
                )}
              </NavLink>
            );
          })}
        </div>

        <div className="hidden lg:flex items-center gap-3 rounded-full bg-coastal-600/70 px-3 py-2 text-sm text-white">
          <a href="tel:07769943317" className="mt-1 hover:text-coastal-200" aria-label="Call 07769943317">
            <FontAwesomeIcon icon={faPhone} className="h-4 w-4" />
          </a>
          <span>|</span>
          <a href="mailto:calmcoasthypnotherapy@hotmail.com" className="mt-1 hover:text-coastal-200" aria-label="Email calmcoasthypnotherapy@hotmail.com">
            <FontAwesomeIcon icon={faEnvelope} className="h-4 w-4" />
          </a>
        </div>

        <a
          href="/#contact"
          onClick={(event) => handleSectionNav(event, "contact")}
          className="text-coastal-900 bg-coastal-100 flex whitespace-nowrap mx-2 px-4 py-2 text-base font-semibold rounded-full hover:bg-white"
        >
          Get In Touch
        </a>

        {/* Mobile navigation */}
        <button className="lg:hidden ml-5 my-auto" onClick={() => setOpen(!open)} aria-controls="mobile-menu" aria-expanded="false">
          <span className="sr-only">Open main menu</span>
          {!open ? (
            <Bars3Icon className="h-10 w-10 text-white" aria-hidden="true" />
          ) : (
            <XMarkIcon className="h-10 w-10 text-white" aria-hidden="true" />
          )}
        </button>
      </div>

      <MobileNavigation navigation={navigation} open={open} setOpen={setOpen} onJumpToSection={handleSectionNav} />

    </nav>
  )
}